import type { BrowserFallbackRegistry } from './types'

export const contextBrowserFallbacks: BrowserFallbackRegistry = {
  'context-db': {
    getClipboardHistory: () => [],
    searchClipboardHistory: () => [],
    getClipboardCount: () => 0,
    clearClipboardHistory: () => true,
    getScreenshotCount: () => 0,
    clearScreenshotHistory: () => true,
    getPrivacyFilters: () => ({
      mode: 'most-useful',
      systemRules: [],
      systemRulesByMode: { 'most-useful': [], 'privacy-first': [] },
      userRules: [],
    }),
    addPrivacyRule: () => ({ ok: false, reason: 'browser_fallback' }),
    updatePrivacyRule: () => ({ ok: false, reason: 'browser_fallback' }),
    removePrivacyRule: () => false,
    resetPrivacyFiltersToDefaults: () => false,
    checkPrivacyRuleConflict: () => null,
    refreshPrivacyDomainMetadata: () => null,
    evaluateFocusedWindowPrivacy: () => ({ allowed: true, reason: 'allowed-by-default' }),
  },
  contextOrchestrator: {
    getSelectedText: () => '',
  },
  'browser-support': {
    getTabs: () => [],
    getBrowserTabContext: () => null,
  },
}
